import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingCart, BarChart3, Settings, LogOut, ArrowLeft, Store, Link } from 'lucide-react';

export function EbaySidebar({ onLogout, onBackToPlatforms, onBackToStores, storeName }) {
  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/products', icon: Package, label: 'Products' },
    { path: '/orders', icon: ShoppingCart, label: 'Orders' },
    { path: '/reports', icon: BarChart3, label: 'Reports' },
    { path: '/sku-mapping', icon: Link, label: 'SKU Mapping' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <div className="w-64 bg-gradient-to-b from-blue-900 to-indigo-800 text-white flex flex-col">
      <div className="p-6 border-b border-blue-700">
        <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-300 to-indigo-300 bg-clip-text text-transparent">
          eBay Manager
        </h1>
        {storeName && (
          <div className="mt-2 flex items-center text-blue-200 text-sm">
            <Store size={14} className="mr-1" />
            <p className="truncate">{storeName}</p>
          </div>
        )}
      </div>

      <nav className="flex-1 p-4 space-y-2">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `flex items-center px-4 py-3 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-gradient-to-r from-blue-600 to-indigo-600 shadow-lg'
                  : 'hover:bg-blue-800'
              }`
            }
          >
            <item.icon size={20} className="mr-3" />
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-blue-700 space-y-2">
        {onBackToStores && (
          <button
            onClick={onBackToStores}
            className="flex items-center w-full px-4 py-3 rounded-lg hover:bg-blue-800 transition-colors text-blue-200"
          >
            <ArrowLeft size={20} className="mr-3" />
            <span className="font-medium">Change Store</span>
          </button>
        )}
        <button
          onClick={onBackToPlatforms}
          className="flex items-center w-full px-4 py-3 rounded-lg hover:bg-purple-700 transition-colors text-purple-200"
        >
          <ArrowLeft size={20} className="mr-3" />
          <span className="font-medium">Change Platform</span>
        </button>
        <button
          onClick={onLogout}
          className="flex items-center w-full px-4 py-3 rounded-lg hover:bg-red-600 transition-colors"
        >
          <LogOut size={20} className="mr-3" />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
}

export default EbaySidebar;